import React from 'react';
import Box from '@material-ui/core/Box';
import { KubernetesMigrationBarChartLegend } from './KubernetesMigrationBarChartLegend.esm.js';
import { KubernetesMigrationBarChart } from './KubernetesMigrationBarChart.esm.js';
import { InfoCard } from '@backstage/core-components';

const KubernetesMigrationAlertCard = ({
  data,
  title,
  subheader,
  currentProduct,
  comparedProduct
}) => {
  return /* @__PURE__ */ React.createElement(InfoCard, { title, subheader }, /* @__PURE__ */ React.createElement(Box, { display: "flex", flexDirection: "column" }, /* @__PURE__ */ React.createElement(Box, { paddingY: 1 }, /* @__PURE__ */ React.createElement(
    KubernetesMigrationBarChartLegend,
    {
      startDate: data.startDate,
      change: data.change,
      currentProduct,
      comparedProduct
    }
  )), /* @__PURE__ */ React.createElement(Box, { paddingY: 1 }, /* @__PURE__ */ React.createElement(
    KubernetesMigrationBarChart,
    {
      services: data.services,
      currentProduct,
      comparedProduct
    }
  ))));
};

export { KubernetesMigrationAlertCard };
//# sourceMappingURL=KubernetesMigrationAlertCard.esm.js.map
